import { MapPin, Phone, Mail } from "lucide-react";
import ContactForm from "@/components/ContactForm";

const CONTACT_IMAGE = "https://static.prod-images.emergentagent.com/jobs/816767a7-7d1c-4aa6-ab45-83326ee2f608/images/b153f87420acf924ea26a7325d720133a7db1bc67346aedf4ef6322edd2f3af1.png";

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-zinc-50" data-testid="contact-page">
      {/* Header */}
      <div className="bg-white border-b border-zinc-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <p className="text-xs uppercase tracking-[0.2em] font-semibold text-[#00B5AD] mb-3">
            Contactez-nous
          </p>
          <h1 className="font-['Outfit'] text-4xl sm:text-5xl tracking-tight font-light text-zinc-900">
            Parlons de votre <span className="font-medium">projet</span>
          </h1>
          <p className="mt-4 text-zinc-600 max-w-2xl">
            Notre équipe est à votre écoute pour répondre à toutes vos questions 
            et vous accompagner dans votre projet immobilier.
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Form */}
          <div className="bg-white border border-zinc-200 p-8" data-testid="contact-form-section">
            <h2 className="font-['Outfit'] text-2xl font-medium text-zinc-900 mb-6">
              Envoyez-nous un message
            </h2>
            <ContactForm />
          </div>

          {/* Contact Info & Image */}
          <div className="space-y-8">
            {/* Info Cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="bg-white border border-zinc-200 p-6" data-testid="contact-address">
                <MapPin className="h-8 w-8 text-[#00B5AD] mb-4" />
                <h3 className="font-['Outfit'] font-medium text-zinc-900 mb-2">Adresse</h3>
                <p className="text-zinc-600 text-sm">
                  Route du Regage<br />
                  13124 Peypin
                </p>
              </div>
              <div className="bg-white border border-zinc-200 p-6" data-testid="contact-phone">
                <Phone className="h-8 w-8 text-[#00B5AD] mb-4" />
                <h3 className="font-['Outfit'] font-medium text-zinc-900 mb-2">Téléphone</h3>
                <a href="tel:0612072367" className="text-zinc-600 text-sm hover:text-[#D62965] transition-colors">
                  07 66 02 00 20
                </a>
              </div>
              <div className="bg-white border border-zinc-200 p-6 sm:col-span-2" data-testid="contact-email">
                <Mail className="h-8 w-8 text-[#00B5AD] mb-4" />
                <h3 className="font-['Outfit'] font-medium text-zinc-900 mb-2">Email</h3>
                <a href="mailto:contactsite@immostaging.fr" className="text-zinc-600 text-sm hover:text-[#D62965] transition-colors">
                  contactsite@immostaging.fr
                </a>
              </div>
            </div>

            {/* Hours */}
            <div className="bg-white border border-zinc-200 p-6" data-testid="contact-hours">
              <h3 className="font-['Outfit'] font-medium text-zinc-900 mb-4">Horaires d'ouverture</h3>
              <ul className="space-y-2 text-sm text-zinc-600">
                <li className="flex justify-between">
                  <span>Lundi - Vendredi</span>
                  <span className="font-medium text-zinc-900">9h00 - 19h00</span>
                </li>
                <li className="flex justify-between">
                  <span>Samedi</span>
                  <span className="font-medium text-zinc-900">9h00 - 12h00</span>
                </li>
                <li className="flex justify-between">
                  <span>Dimanche</span>
                  <span className="text-zinc-400">Fermé</span>
                </li>
              </ul>
            </div>

            {/* Image */}
            <div 
              className="h-64 lg:h-80 bg-cover bg-center"
              style={{ backgroundImage: `url(${CONTACT_IMAGE})` }}
              data-testid="contact-image"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
